import React, { Fragment, useEffect, useState } from 'react';
import { UTLabel, UTButton, UTCard } from '@widergy/energy-ui';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { connect } from 'react-redux';
import { any, arrayOf, bool } from 'prop-types';
import { push } from 'connected-react-router';

import { message } from 'utils/stringUtils';
import { actionCreators as UserActions } from 'redux/user/actions';
import { ROUTES } from 'constants/routes';
import UTModal from 'app/components/UTModal';

import GridWrapper from '../components/GridWrapper';

import { PENDING } from './constants';
import CardNextTurn from './components/CardNextTurn';
import styles from './styles.module.scss';

const MyTurnsContainer = ({ userTurns, dispatch, userTurnsLoading, updateUserTurnsLoading }) => {
  useEffect(() => {
    if (!updateUserTurnsLoading) dispatch(UserActions.getUserTurns(PENDING));
  }, [updateUserTurnsLoading]);

  const [cancelTurn, setCancelTurn] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = id => {
    setCancelTurn(id);
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleCancelTurn = () => {
    dispatch(UserActions.cancelTurn(cancelTurn));
    handleCloseModal();
  };

  const acceptButton = {
    text: message(`Commons:accept`),
    onPress: handleCancelTurn
  };
  const cancelButton = {
    text: message(`Commons:cancel`),
    onPress: handleCloseModal
  };

  const handleRequestTurns = () => dispatch(push(ROUTES.NEW_TURN));
  const renderRows = item => <CardNextTurn {...item} openCancelModal={handleOpenModal} />;
  return (
    <div>
      <UTLabel large bold className={styles.title}>
        {message('Turns:myTurns')}
      </UTLabel>
      <UTCard flat className={styles.containerCard}>
        <div className={styles.cardContent}>
          <UTLabel darkGray large extrabold className={styles.label}>
            {message('Turns:requestTurnTitle')}
          </UTLabel>
          <UTLabel darkGray className={styles.label}>
            {message('Turns:requestTurnSubtitle')}
          </UTLabel>
          <UTButton className={styles.button} onPress={handleRequestTurns}>
            {message('Turns:requestTurn')}
          </UTButton>
        </div>
      </UTCard>
      <GridWrapper
        title={message('Turns:nextTurns')}
        loading={userTurnsLoading || updateUserTurnsLoading}
        hasElements={!isEmpty(userTurns)}
      >
        {isEmpty(userTurns) ? (
          <div className={styles.withoutTurns}>
            <UTLabel darkGray extrabold large className={styles.label}>
              {message('Turns:withoutTurnsTitle')}
            </UTLabel>
            <UTLabel darkGray className={styles.label}>
              {message('Turns:withoutTurnsSubtitle')}
            </UTLabel>
          </div>
        ) : (
          <Fragment>{userTurns.map(renderRows)}</Fragment>
        )}
      </GridWrapper>
      <UTModal
        isOpen={openModal}
        onRequestClose={handleCloseModal}
        title={message('Turns:cancelationTurnTitle')}
        acceptButton={acceptButton}
        cancelButton={cancelButton}
      >
        <div className={styles.containerModal}>
          <UTLabel>{message('Turns:cancelationTurnContent')}</UTLabel>
        </div>
      </UTModal>
    </div>
  );
};

MyTurnsContainer.propTypes = {
  userTurns: arrayOf(any),
  userTurnsLoading: bool,
  updateUserTurnsLoading: bool
};

const mapStateToProps = store => ({
  userTurns: store.user.userTurns,
  userTurnsLoading: store.user.userTurnsLoading,
  updateUserTurnsLoading:
    store.user.cancelTurnLoading || store.user.updateTurnLoading || store.user.createNewTurnLoading
});

export default connect(mapStateToProps)(MyTurnsContainer);
